<template>
  <div>
    <v-button @click="openSuggestionModal" :button-text="buttonText || 'Optimize Et'" :size="size || 'sm'" :color="color || 'secondary'" :icon="icon || 'auto_fix_high'" :class="buttonClass"/>

    <create-suggestion-modal v-if="isValidContentId" v-model="showSuggestionModal" :content-id="contentId" :content-model="contentModel" :content-type="contentType" :content-category="contentCategory" :current-text="currentText || ''" :current-image-url="currentImageUrl || ''" :current-video-url="currentVideoUrl || ''" @suggestion-created="handleSuggestionCreated"/>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import VButton from '@/components/base/buttons/VButton.vue'
import CreateSuggestionModal from '@/components/suggestions/components/modals/CreateSuggestionModal.vue'
import { CONTENT_TYPES, CONTENT_CATEGORIES } from '@/components/suggestions/constants/suggestions'
import { responseHandlerService } from '@/plugins/responseHandlerService'


const props = defineProps({
  // İçerik tanımlayıcıları
  contentId: {
    type: [String, Number],
    required: true,
  },
  contentModel: {
    type: String,
    required: true,
    validator: (value) => ['Image', 'TextContent', 'Video'].includes(value),
  },
  contentType: {
    type: String,
    required: true,
    validator: (value) => Object.values(CONTENT_TYPES).includes(value),
  },
  contentCategory: {
    type: String,
    required: true,
    validator: (value) => Object.values(CONTENT_CATEGORIES).includes(value),
  },

  // Mevcut içerik verileri (içerik tipine göre)
  currentText: {
    type: String,
    default: '',
  },
  currentImageUrl: {
    type: String,
    default: '',
  },
  currentVideoUrl: {
    type: String,
    default: '',
  },

  // Buton özelleştirme
  buttonText: String,
  size: String,
  color: String,
  icon: String,
  buttonClass: String,
})

const emit = defineEmits(['suggestion-created'])
const showSuggestionModal = ref(false)

// ContentId geçerli mi kontrolü
const isValidContentId = computed(() => {
  return props.contentId !== undefined && props.contentId !== null
})

const openSuggestionModal = () => {
  if (!isValidContentId.value) {
    responseHandlerService.handleError(null, 'Geçerli bir içerik ID\'si olmadan öneri oluşturulamaz')
    return
  }
  showSuggestionModal.value = true
}

const handleSuggestionCreated = (suggestion) => {
  emit('suggestion-created', suggestion)
  showSuggestionModal.value = false
}
</script>